import { Webpage, Livecenter, RaceLivepage, Language, NewMyWebSocketType, NewChanges } from './common/types'
import { HandleChangesNew } from './common/changes'
import { NewWebsocket } from './common/mywebsocket'
import { GetInitialLanguage, UpdateLanguage } from './common/i18n';
import { StartPingTimer } from './common/ping';
import Hls from 'hls.js';
import { FormatDate, ParseDateOnly } from './common/datetime';

const urlParams: URLSearchParams = new URLSearchParams(window.location.search)
const eventId: string = urlParams.get('event_id');

let webSocket: NewMyWebSocketType = null;
let currentLanguage: Language = GetInitialLanguage();

window.onload = function () {
    ReStartListeners();
    setInterval(PrintAudioPlayerState, 500);

    (document.getElementById('language-en-us') as HTMLImageElement).onclick = function () {
        currentLanguage = UpdateLanguage('en-US', false);
        ReStartListeners();
    };

    (document.getElementById('language-nb-no') as HTMLImageElement).onclick = function () {
        currentLanguage = UpdateLanguage('nb-NO', false);
        ReStartListeners();
    };

    currentLanguage = UpdateLanguage(currentLanguage.code, true);

    StartPingTimer('event.html?event_id=' + eventId, function () {
        return {
            'language': currentLanguage.code,
            'audio_playing': cachedPaused == null ? false : !cachedPaused
        };
    });
}

let races: RaceLivepage[] = [];

function ReStartListeners(): void {
    if (webSocket != null) {
        webSocket.Close();
    }

    webSocket = new NewWebsocket(eventId, ['races', 'livecenter'], false);
    webSocket.DataReceived = function (collectionName, data, fullReload, idFieldsFromManifest) {
        switch (collectionName) {
            case 'races':
                const raceChanges = data as NewChanges<RaceLivepage>;

                HandleChangesNew(
                    fullReload,
                    raceChanges,
                    races,
                    () => { },
                    idFieldsFromManifest);
                PrintRaces();
                break;
            case 'livecenter':
                const livecenterChanges: NewChanges<Livecenter> = data;
                if (livecenterChanges.upsert.length > 0) {
                    PrintLivesenter(livecenterChanges.upsert[0]);
                }
                break;
        }
    }
}


function CreateListUrl(url: string, text: string) {
    let href = document.createElement('a');
    href.innerText = text;
    href.href = url;
    href.target = '_blank';

    let li = document.createElement('li');
    li.appendChild(href);
    return li;
}

function GetWebPagesWithDescription(webpages: Webpage[]): Webpage[] {
    let out: Webpage[] = [];
    for (let i = 0; i < webpages.length; ++i) {
        if (webpages[i].description.length > 0) {
            out.push(webpages[i]);
        }
    }

    return out;
}

function CreateUrlList(webPagesArray: Webpage[][], containerElementId: string, header: string, subheader: string): void {
    let listsElement = document.getElementById(containerElementId);
    listsElement.innerHTML = '';

    let webPages: Webpage[] = [];
    for (const webPage of webPagesArray) {
        let filteredWebPages = GetWebPagesWithDescription(webPage);
        for (const filteredWebPage of filteredWebPages) {
            webPages.push(filteredWebPage);
        }

    }

    if (webPages.length > 0) {
        let ul = document.createElement('ul');

        for (const webPage of webPages) {
            ul.appendChild(CreateListUrl(webPage.url, webPage.description));
        }

        CreateBoxContents(listsElement, header, subheader, ul);
    }
}

const AUTOSTART_AUDIO_STORAGE_KEY = 'autostart_audio';
const AUDIO_ANNOUNCED_MARKER = 'announced';
let HLSPlayer: Hls = null;

function PrintAudioPlayer(audioContainer: HTMLDivElement): void {
    if (AudioPlayerType(document.createElement('audio')) == AudioPlayerEnum.NotSupported) {
        audioContainer.innerText = currentLanguage.livecenter_audio_not_supported;
        return;
    }


    if (audioUrl == AUDIO_ANNOUNCED_MARKER) {
        let container = document.createElement('div');
        let checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = 'autostart_audio';
        checkbox.onchange = function (event) {
            const checked = (event.target as HTMLInputElement).checked;
            localStorage.setItem(AUTOSTART_AUDIO_STORAGE_KEY, checked ? '1' : '0');
        }

        const autoStart = localStorage.getItem(AUTOSTART_AUDIO_STORAGE_KEY);
        if (autoStart != null && autoStart == '1') {
            checkbox.checked = true;
        }

        container.appendChild(document.createElement('br'));
        container.appendChild(checkbox);

        let label = document.createElement('label');
        label.htmlFor = checkbox.id;
        label.textContent = currentLanguage.livecenter_audio_autostart;
        container.appendChild(label);

        CreateBoxContents(audioContainer, currentLanguage.livecenter_audio_player_heading, currentLanguage.livecenter_audio_to_be_started, container);
        return;
    }

    let audioElement = document.createElement('audio');
    audioElement.id = 'audio-player';
    audioElement.preload = 'none';

    audioElement.appendChild(document.createTextNode(currentLanguage.livecenter_audio_not_supported));

    let audioContents = document.createElement('div');
    audioContents.appendChild(audioElement);

    let playController = document.createElement('div');
    playController.id = 'audio-play-controller';
    playController.innerText = currentLanguage.livecenter_start_audio;
    playController.onclick = PlayControllerClicked;
    audioContents.appendChild(playController);

    let playControllerStatus = document.createElement('div');
    playControllerStatus.id = 'audio-play-controller-status';
    playControllerStatus.classList.add('audio-status');
    playControllerStatus.innerText = currentLanguage.livecenter_audio_stopped;
    audioContents.appendChild(playControllerStatus);

    CreateBoxContents(audioContainer, currentLanguage.livecenter_audio_player_heading, currentLanguage.livecenter_audio_player_subheading, audioContents);
}

function PrintLivesenter(livecenter: Livecenter): void {
    document.getElementById('event-description').innerText = livecenter.event_description;

    let eventUrls = document.getElementById('event-main-urls');
    eventUrls.innerHTML = '';
    if (livecenter.organizer_url.length > 0) {
        eventUrls.appendChild(CreateListUrl(livecenter.organizer_url, currentLanguage.livecenter_organizer_homepage));
    }

    if (livecenter.pm_url.length > 0) {
        eventUrls.appendChild(CreateListUrl(livecenter.pm_url, currentLanguage.livecenter_pm));
    }

    if (livecenter.video_url.length > 0) {
        eventUrls.appendChild(CreateListUrl(livecenter.video_url, currentLanguage.livecenter_video_stream));
    }


    if (livecenter.audio_url != audioUrl) {
        if (HLSPlayer != null) {
            HLSPlayer.destroy();
        }

        const audioPlayer = document.getElementById('audio-player') as HTMLAudioElement;
        const autoStart = localStorage.getItem(AUTOSTART_AUDIO_STORAGE_KEY);
        const autoPlayAudio = (audioPlayer != null && !audioPlayer.paused) || (autoStart != null && autoStart == '1' && audioUrl == AUDIO_ANNOUNCED_MARKER);

        let audioContainer = document.getElementById('event-audio') as HTMLDivElement;
        audioContainer.innerHTML = '';

        audioUrl = livecenter.audio_url;
        if (livecenter.audio_url.length > 0) {
            PrintAudioPlayer(audioContainer);

            if (autoPlayAudio) {
                PlayControllerClicked();
            }
        }
    }

    CreateUrlList([livecenter.startlists, livecenter.resultlists],
        'event-official-lists',
        currentLanguage.livecenter_official_lists_heading,
        currentLanguage.livecenter_official_lists_subheading);

    CreateUrlList([livecenter.gps],
        'event-gps-links',
        currentLanguage.livecenter_gps_heading,
        null);

    CreateUrlList([livecenter.external],
        'event-external-links',
        currentLanguage.livecenter_external_pages_heading,
        null);
}

let audioUrl: string = null;
let cachedPaused: boolean = null;
let cachedNetworkState: number = null;
let cachedReadyState: number = null;
function PrintAudioPlayerState() {
    let audioPlayer = document.getElementById('audio-player') as HTMLAudioElement;
    if (audioPlayer == null) {
        cachedPaused = null;
        cachedNetworkState = null;
        cachedReadyState = null;
        return;
    }

    if (cachedPaused == audioPlayer.paused &&
        cachedNetworkState == audioPlayer.networkState &&
        cachedReadyState == audioPlayer.readyState) {

        return;
    }

    cachedPaused = audioPlayer.paused;
    cachedNetworkState = audioPlayer.networkState;
    cachedReadyState = audioPlayer.readyState;

    let audioPlayerStatus = document.getElementById('audio-play-controller-status');
    let audioPlayerButton = document.getElementById('audio-play-controller');

    audioPlayerStatus.classList.remove('error-color');
    audioPlayerStatus.classList.remove('warning-color');
    audioPlayerStatus.classList.remove('ok-color');

    if (cachedPaused) {
        audioPlayerButton.innerText = currentLanguage.livecenter_start_audio;
        audioPlayerStatus.innerText = currentLanguage.livecenter_audio_stopped;
    } else {
        audioPlayerButton.innerText = currentLanguage.livecenter_stop_audio;

        if (cachedNetworkState == 3) {
            audioPlayerStatus.innerText = currentLanguage.livecenter_audio_could_not_load;
            audioPlayerStatus.classList.add('error-color');
        } else {
            switch (cachedReadyState) {
                case 0:
                case 1:
                case 2:
                    audioPlayerStatus.innerText = currentLanguage.livecenter_audio_loading;
                    audioPlayerStatus.classList.add('warning-color');
                    break;
                case 3:
                case 4:
                    audioPlayerStatus.innerText = currentLanguage.livecenter_audio_loaded;
                    audioPlayerStatus.classList.add('ok-color');
                    break;
            }
        }
    }
}

enum AudioPlayerEnum {
    Native, Hls, NotSupported
};

function AudioPlayerType(audioPlayerElement: HTMLAudioElement): AudioPlayerEnum {
    // Prefer native streaming initially, and fall back to hls.js
    if (!audioUrl.endsWith('.m3u8')) {
        // Assume regular audio streaming from icecast.
        return AudioPlayerEnum.Native;
    }


    if (audioPlayerElement.canPlayType('application/vnd.apple.mpegurl')) {
        return AudioPlayerEnum.Native;
    }

    if (Hls.isSupported()) {
        return AudioPlayerEnum.Hls;
    }

    return AudioPlayerEnum.NotSupported;
}


function PlayControllerClicked(): void {
    let audioPlayer = document.getElementById('audio-player') as HTMLMediaElement;

    if (audioPlayer.paused) {
        switch (AudioPlayerType(audioPlayer)) {
            case AudioPlayerEnum.Native:
                audioPlayer.src = audioUrl;
                audioPlayer.load();
                break;
            case AudioPlayerEnum.Hls:
                HLSPlayer = new Hls();
                HLSPlayer.loadSource(audioUrl);
                HLSPlayer.attachMedia(audioPlayer);
                break;
        }

        audioPlayer.play();
    } else {
        audioPlayer.pause();

        // Remove src to avoid the device from continue loading data.
        audioPlayer.src = '';

        if (HLSPlayer != null) {
            HLSPlayer.destroy();
            HLSPlayer.stopLoad();
        }
    }
}

function PrintRaces() {
    let racesElement = document.getElementById('event-races');
    racesElement.innerHTML = '';

    races.sort(function (a, b) {
        const cmp = Date.parse(a.date) - Date.parse(b.date);
        if (cmp == 0) {
            return a.description.localeCompare(b.description);
        }
        return cmp;
    })

    let list = document.createElement('ul');
    for (const race of races) {
        const plusIndex = race.date.indexOf("+");
        // Ignore any timezone on purpose. Reasoning:
        // - All time/dates from Liveresultater has timezone.
        // - date has the time part set to zero, so it might look like
        //   '2023-01-09T00:00:00+02:00'
        // - But this will change date in "earlier" timezones if we care about timezone.
        let raceDate = ParseDateOnly(race.date);
        const text = FormatDate(raceDate, 'dd.mm') + ' - ' + race.description;
        list.appendChild(CreateListUrl('race.html?id=' + race.race_id, text));
    }
    CreateBoxContents(racesElement, currentLanguage.livecenter_live_results_heading, currentLanguage.livecenter_live_results_subheading, list);
}

function CreateBoxContents(boxElement: HTMLElement, header: string, subheader: string, content: HTMLElement) {
    let headerElement = document.createElement('div');
    headerElement.classList.add('header');
    headerElement.innerText = header;
    boxElement.appendChild(headerElement);

    if (subheader !== null) {
        let subHeaderElement = document.createElement('div');
        subHeaderElement.classList.add('subheader');
        subHeaderElement.innerText = subheader;
        boxElement.appendChild(subHeaderElement);
    }

    boxElement.appendChild(content);
}
